function NewFundingOutstandingAmountWidget({ fundingFeesSum, fundingOutstandingAmount }) {
  return (
    <div className="bo-border-container bg-light rounded w-100 p-0">
      <div className="p-2">
        <div className="d-flex justify-content-between pb-1">
          <p className="bo-common-text">Paid Fees</p>
          <p className="bo-common-text">${fundingFeesSum}</p>
        </div>
        <div className="d-flex justify-content-between">
          <p className="bo-common-text-bold">Outstanding Amount</p>
          <p className="bo-common-text-bold">${fundingOutstandingAmount}</p>
        </div>
      </div>
    </div>
  );
}

export default NewFundingOutstandingAmountWidget;
